const _IS_DEV = () => process.env.NODE_ENV === 'development'
const _IS_PROD = () => process.env.NODE_ENV === 'production'

/**
 * Check if analytics should be enabled
 * Only enables GTM and Mixpanel in production environment
 * Disabled in localhost and staging to avoid polluting analytics data
 */
export const isAnalyticsEnabled = () => {
  return process.env.NODE_ENV === 'production' && process.env.VITE_APP_ENVIRONMENT === 'production'
}

/** The environment this bundle was built for, as every analytics event reports it ('unknown' when unset). */
export const ANALYTICS_ENVIRONMENT = () => process.env.VITE_APP_ENVIRONMENT || 'unknown'

export const APP_ENV = () => (process.env.VITE_APP_ENVIRONMENT === 'staging' ? 'staging' : 'production')

const _IS_APP_ENV_STAGING = () => APP_ENV() === 'staging'
